import { SimpleProduct, WarrantyGroup } from '@msdyn365-commerce/retail-proxy';
import React, { Fragment } from 'react';

export interface IWarrantySelectionResources {
    productProtectionLabel?: string,
    noPlanSelectedLabel?: string,
    dayLabel?: string,
    monthLabel?: string,
    yearLabel?: string
}
export interface IWarrantySelectionProps {
    warrantyGroups: WarrantyGroup[];
    selectedWarranty: number;
    formatPriceFn(price: string | number, currencyCode?: string | undefined): string;
    setSelectedWarranty(warranty: SimpleProduct | undefined): void;
    resources: IWarrantySelectionResources
}

export const WarrantySelection = (props: IWarrantySelectionProps) => {
    const { warrantyGroups, selectedWarranty, formatPriceFn, setSelectedWarranty, resources } = props;
    const isWarrantyGroupValid = (): boolean => {
        return Boolean(warrantyGroups && Array.isArray(warrantyGroups) && warrantyGroups.length && warrantyGroups[0].Warranties);
    };

    const handleWarrantyChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (Number(event.target.value) !== 0) {
            const warranty = warrantyGroups[0].Warranties!.find(w => w.RecordId === Number(event.target.value));
            setSelectedWarranty(warranty as SimpleProduct);
        } else {
            setSelectedWarranty(undefined);
        }
    };

    const getWarrantyDurationLabel = (valueEnum: number, isPlural: boolean): string | null => {
        let valueLabel;
        switch (valueEnum) {
            case 1:
                valueLabel = resources.dayLabel!;
                break;
            case 2:
                valueLabel = resources.monthLabel!;
                break;
            case 3:
                valueLabel = resources.yearLabel!;
                break;
            default:
                return null;
        }
        if (isPlural) {
            valueLabel += 's';
        }
        return valueLabel;
    };

    return (
        <>
            <div className={'warranty-selection'}>
                {isWarrantyGroupValid() ? (
                    <>
                        <p className={'warranty-selection__title'}>{resources.productProtectionLabel}</p>
                        <div className={'warranty-selection-block'}>
                            <input
                                type={'radio'}
                                role={'radio'}
                                id={'no_plan'}
                                name={'warranty_selection'}
                                value={0}
                                onChange={handleWarrantyChange}
                                aria-checked={selectedWarranty === 0}
                                checked={selectedWarranty === 0}
                            />
                            <label htmlFor={'no_plan'} className={'warranty-selection__option'}>
                                <span className={'warranty-selection__option-label'}>{resources.noPlanSelectedLabel}</span>
                            </label>
                            {warrantyGroups[0].Warranties!.map(warranty => (
                                <Fragment
                                    key={warranty.ItemId}>
                                    <input
                                        key={warranty.ItemId}
                                        type={'radio'}
                                        role={'radio'}
                                        name={'warranty_selection'}
                                        id={`${warranty.RecordId}_plan`}
                                        value={warranty.RecordId}
                                        onChange={handleWarrantyChange}
                                        checked={selectedWarranty === warranty.RecordId}
                                        aria-checked={selectedWarranty === warranty.RecordId}
                                    />
                                    <label htmlFor={`${warranty.RecordId}_plan`} className={'warranty-selection__option'}>
                                        <span className={'warranty-selection__option-label'}>
                                            {warranty.Duration}{' '}
                                            {getWarrantyDurationLabel(
                                                warranty.DurationUnitValue!,
                                                (warranty.Duration && warranty.Duration > 1) || false
                                            )}
                                        </span>
                                        <span className={'warranty-selection__option-price'}>{formatPriceFn(warranty.AdjustedPrice)}</span>
                                    </label>
                                </Fragment>
                            ))}
                        </div>
                    </>
                ) : null}
            </div>
        </>
    );
};
